module.exports = __webpack_public_path__ + "img/airPurifiers_0_1.2af40e21.png";